import storage from 'redux-persist/lib/storage'; // localStorage — persists across tabs and browser restarts

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['onboarding'], // Specify the reducers you want to rehydrate
  // Add any other config options you need here
};

export default persistConfig;
